const VMPatchingSchduleOptions = [
	{value: '1stSun10am', text: '1st Sunday at 10am'},
	{value: '1stSun9pm', text: '1st Sunday at 9pm'},
	{value: '1stMon10am', text: '1st Monday at 10am'},
	{value: '1stMon9pm', text: '1st Monday at 9pm'},
	{value: '1stTue10am', text: '1st Tuesday at 10am'},
	{value: '1stTue9pm', text: '1st Tuesday at 9pm'},
	{value: '1stWed10am', text: '1st Wednesday at 10am'},
	{value: '1stWed9pm', text: '1st Wednesday at 9pm'},
	{value: '1stThu10am', text: '1st Thursday at 10am'},
	{value: '1stThu9pm', text: '1st Thursday at 9pm'},
	{value: '1stFri10am', text: '1st Friday at 10am'},
	{value: '1stFri9pm', text: '1st Friday at 9pm'},
	{value: '1stSat10am', text: '1st Saturday at 10am'},
	{value: '1stSat9pm', text: '1st Saturday at 9pm'},
	{value: '2ndTue9pm', text: '2st Tuesday at 9pm'},
	{value: '3rdSun10am', text: '3rd Sunday at 9pm'},
	{value: '3rdSun9pm', text: '3rd Sunday at 9pm'},
	{value: '3rdMon10am', text: '3rd Monday at 10am'},
	{value: '3rdMon9pm', text: '3rd Monday at 9pm'},
	{value: '3rdTue10am', text: '3rd Tuesday at 10am'},
	{value: '3rdTue9pm', text: '3rd Tuesday at 9pm'},
	{value: '3rdWed10am', text: '3rd Wednesday at 10am'},
	{value: '3rdWed9pm', text: '3rd Wednesday at 9pm'},
	{value: '3rdThu10am', text: '3rd Thursday at 10am'},
	{value: '3rdThu9pm', text: '3rd Thursday at 9pm'},
	{value: '3rdFri10am', text: '3rd Friday at 10am'},
	{value: '3rdFri9pm', text: '3rd Friday at 9pm'},
	{value: '3rdSat10am', text: '3rd Saturday at 10am'},
	{value: '3rdSat9pm', text: '3rd Saturday at 9pm'},
	{value: '4thSun10am', text: '4th Sunday at 10am'},
	{value: '4thSun9pm', text: '4th Sunday at 9pm'},
	{value: '4thMon10am', text: '4th Monday at 10am'},
	{value: '4thMon9pm', text: '4th Monday at 9pm'},
	{value: '4thTue10am', text: '4th Tuesday at 10am'},
	{value: '4thTue9pm', text: '4th Tuesday at 9pm'},
	{value: '4thWed10am', text: '4th Wednesday at 10am'},
	{value: '4thWed9pm', text: '4th Wednesday at 9pm'},
	{value: '4thThu10am', text: '4th Thursday at 10am'},
	{value: '4thThu9pm', text: '4th Thursday at 9pm'},
	{value: '4thFri10am', text: '4th Friday at 10am'},
	{value: '4thFri9pm', text: '4th Friday at 9pm'},
	{value: '4thSat10am', text: '4th Saturday at 10am'},
	{value: '4thSat9pm', text: '4th Saturday at 9pm'},
	{value: 'WeeklySat10am', text: 'Weekly every Saturday at 10am'},
	{value: 'WeeklySat9pm', text: 'Weekly every Saturday at 9pm'},
	{value: 'WeeklySun10am', text: 'Weekly every Sunday at 10am'},
	{value: 'WeeklySun9pm', text: 'Weekly every Sunday at 9pm'},
];

export default VMPatchingSchduleOptions;